export const LOCALE = {
    BE_FR: 'be-fr',
    BE_EN: 'be-en',
    BE_DE: 'be-de',
    BE_NL: 'be-nl',
    FR_FR: 'fr-fr',
    FR_EN: 'fr-en',
    NL_NL: 'nl-nl',
    NL_EN: 'nl-en',
} as const;

export type Locale = Enum<typeof LOCALE>;
